import { RouteConfig } from 'vue-router';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { AuthResource, authResource } from '@/resources/auth.resource';
import { mainRoute } from '@/router/main.route';
import { buildMenu } from '@/utils/menu';
import store from '../store';
import { AbstractModule } from './abstract.module';

/**
 * Moduł menu
 *
 * @export
 * @class MenuModule
 * @extends {AbstractModule<AuthResource>}
 */
export class MenuModule extends AbstractModule<AuthResource> {
  /**
   * Stan modułu
   *
   * @memberof MenuModule
   */
  public state = {
    menu: {}
  };

  public mutations = {
    /**
     * Zapisuje menu
     *
     * @param {*} localState
     * @param {*} menu
     */
    saveMenu(localState: any, menu: any): void {
      localState.menu = menu;
    }
  };

  public actions = {
    /**
     * Buduje menu
     *
     * @param {*} context
     * @param {string} [query]
     * @returns {Promise<void>}
     */
    getMenu(context: any, query?: string): Promise<void> {
      const menuItemsFromSettings: any[] = JSON.parse(
        context.rootState.setting.settings[PublicSettings.SIDE_MENU].value
      );
      const menuItemsWithTemplateId: any[] = menuItemsFromSettings.filter(menuItem => !!menuItem.templateId);

      return Promise.all(
        menuItemsWithTemplateId.map(menuItem => store.dispatch('procedure/getIdByTemplate', menuItem.templateId))
      )
        .then(() => {
          menuItemsWithTemplateId.forEach(menuItem => {
            const procedureId = store.state.procedure.templatesMap[menuItem.templateId];
            menuItem.entityId = procedureId.toString();
            menuItem.params = { ...menuItem.params, procedureId };
          });
          const menu = buildMenu(mainRoute.children as RouteConfig[], query, menuItemsFromSettings);
          context.commit('saveMenu', menu);
        })
        .catch(err => {
          console.warn(err);
          throw err;
        });
    }
  };
}

export default new MenuModule(authResource);
